const getInputError = (input, form) => {
    const errors = input.validate && !input.hidden &&
        input.validate.find(({ pattern }) => {
            if (pattern instanceof RegExp) return !new RegExp(pattern).test(input.value || '');
            if (typeof pattern === 'function') return pattern(input, form);
            return false;
        });
    return errors ? errors.message : null;
};

const getFormErrors = (form) => {
    const errors = Object.keys(form).reduce((p, key) => ({
        ...p,
        [key]: {
            ...form[key],
            error: getInputError(form[key], form),
        },
    }), {});
    return [
        errors,
        !!Object.values(errors).find(({ error }) => error),
    ];
};

const EmailRegex = /^\w+((\.|[-+]+|\.-)\w+)*-*@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*\.[a-zA-Z]{2,}$/i;

const ValidatePostCodes = {
    digits4: [
        'AF', 'AL', 'AM', 'AT', 'AU', 'BD', 'BE', 'BG', 'BO', 'CC', 'CH', 'CV', 'CX', 'CY', 'DK', 'ET', 'GE', 'GL',
        'GW', 'HM', 'HT', 'HU', 'LI', 'LR', 'LU', 'MD', 'MK', 'MZ', 'NE', 'NF', 'NO', 'NZ', 'PH', 'PY', 'SI', 'SJ',
        'SV', 'TN', 'VE', 'ZA',
    ],
    digits5: [
        'AS', 'BA', 'BL', 'CR', 'CU', 'DE', 'DO', 'DZ', 'EE', 'EG', 'EH', 'ES', 'FI', 'FM', 'FR', 'GF', 'GP', 'GT',
        'GU', 'HN', 'HR', 'ID', 'IQ', 'IT', 'JO', 'KE', 'KH', 'KW', 'LA', 'LK', 'LT', 'LY', 'MA', 'ME', 'MF', 'MH',
        'MM', 'MP', 'MQ', 'MX', 'MY', 'NA', 'NC', 'NP', 'PE', 'PF', 'PK', 'PM', 'PR', 'PW', 'RE', 'RS', 'SA', 'SD',
        'SM', 'SN', 'SS', 'TD', 'TH', 'TR', 'UA', 'US', 'UY', 'VI', 'WF', 'YT', 'ZM',
    ],
};

const Validate = {
    required: {
        pattern: /.+/,
        message: 'form.error_message.required',
    },
    maxLength20: {
        pattern: /^.{0,20}$/,
        message: 'form.error_message.max_length_20',
    },
    maxLength40: {
        pattern: /^.{0,40}$/,
        message: 'form.error_message.max_length_40',
    },
    maxLength60: {
        pattern: /^.{0,60}$/,
        message: 'form.error_message.max_length_60',
    },
    identityDocument: {
        pattern: /^.{6,}$/,
        message: 'form.error_message.identity_document',
    },
    email: {
        pattern: EmailRegex,
        message: 'form.error_message.email',
    },
    password: {
        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/,
        message: 'form.error_message.password_invalid_format',
    },
    passwordConfirmation: {
        // return true if error
        pattern: (input, form) => {
            const password = form.password || form.find((f) => f.id === 'password');
            return password.value && password.value !== input.value;
        },
        message: 'form.error_message.password_match',
    },
    phone: {
        pattern: /^[0-9+()\s]{8,}$/,
        message: 'form.error_message.phone',
    },
    postcodeEs: {
        // return true if error
        pattern: (input, form) => {
            const country = form.country || form.find((f) => f.id === 'country');
            if (country.value !== 'ES') return false;
            return !/^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/.test(input.value || '');
        },
        message: 'form.error_message.postcode_es',
    },
    postcodeEsDest: {
        // return true if error
        pattern: (input, form) => {
            const country = form.country || form.find((f) => f.id === 'country');
            if (country.value !== 'ES') return false;
            return /^(52|51)/.test(input.value || '');
        },
        message: 'form.error_message.postcode_es_dest',
    },
    postcodePt: {
        // return true if error
        pattern: (input, form) => {
            const country = form.country || form.find((f) => f.id === 'country');
            if (country.value !== 'PT') return false;
            return !/(^\d{4}-\d{3}$)/.test(input.value || '');
        },
        message: 'form.error_message.postcode_pt',
    },
    postcodeGb: {
        // return true if error
        pattern: (input, form) => {
            const country = form.country || form.find((f) => f.id === 'country');
            if (country.value !== 'GB') return false;
            return !/^([A-Z][A-HJ-Y]?\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/i.test(input.value || '');
        },
        message: 'form.error_message.postcode_gb',
    },
    postcode4digit: {
        // return true if error
        pattern: (input, form) => {
            const country = form.country || form.find((f) => f.id === 'country');
            if (ValidatePostCodes.digits4.indexOf(country.value) < 0) return false;
            return !/^\d{4}$/i.test(input.value || '');
        },
        message: 'form.error_message.postcode_4',
    },
    postcode5digit: {
        // return true if error
        pattern: (input, form) => {
            const country = form.country || form.find((f) => f.id === 'country');
            if (ValidatePostCodes.digits5.indexOf(country.value) < 0) return false;
            return !/^\d{5}$/i.test(input.value || '');
        },
        message: 'form.error_message.postcode_5',
    },
};

const Validator = {
    getInputError,
    getFormErrors,
    rules: Validate,
};

export default Validator;
